import { waitForElementWithDefinition } from './waitForElement';

/**
 * Aguarda o symplaAuthComponent estar completamente pronto para uso
 * @param timeout Timeout em milissegundos para aguardar o elemento (padrão: 3000ms)
 * @param maxRetries Número máximo de tentativas para aguardar window.symplaAuthComponent (padrão: 10)
 * @param retryDelay Delay entre tentativas em milissegundos (padrão: 200ms)
 * @returns Promise que resolve com true se o componente estiver pronto, false caso contrário
 */
export async function waitForSymplaAuthComponent(
  timeout = 3000,
  maxRetries = 10,
  retryDelay = 200,
): Promise<boolean> {
  try {
    const authElement = await waitForElementWithDefinition('auth-component', timeout);

    if (!authElement) {
      return false;
    }
    let attempts = 0;

    /* eslint-disable no-await-in-loop */
    while (attempts < maxRetries) {
      if (window.symplaAuthComponent) {
        return true;
      }

      await new Promise<void>((resolve) => {
        setTimeout(resolve, retryDelay);
      });

      attempts += 1;
    }
    /* eslint-enable no-await-in-loop */

    return false;
  } catch (error) {
    return false;
  }
}

/**
 * Aguarda especificamente o método logout estar disponível no symplaAuthComponent
 * @param timeout Timeout em milissegundos (padrão: 3000ms)
 * @param maxRetries Número máximo de tentativas (padrão: 10)
 * @param retryDelay Delay entre tentativas em milissegundos (padrão: 200ms)
 * @returns Promise que resolve com true se o método logout estiver disponível, false caso contrário
 */
export async function waitForSymplaAuthLogout(
  timeout = 3000,
  maxRetries = 10,
  retryDelay = 200,
): Promise<boolean> {
  const isReady = await waitForSymplaAuthComponent(timeout, maxRetries, retryDelay);

  if (!isReady) {
    return false;
  }

  if (window.symplaAuthComponent?.logout && typeof window.symplaAuthComponent.logout === 'function') {
    return true;
  }

  return false;
}
